/*
 * @Author: 
 * @Desc:  
 * @Date: 2024-05-09 18:44:35
 * @LastEditors: lqj
 * @LastEditTime: 2024-07-18 16:12:29
 */
import axios from 'axios';
import router from '@/router'

const pendingRequests = new Map();

const generateRequestKey = (config) => {
    // 处理请求数据，确保请求和响应时一致,response返回的config中可能存在序列化的data，需要转换成json格式，否则生成的key不一致
    const normalizeData = (data) => {
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch {
          return data;
        }
      }
      return data;
    };
    
    return [
      config.method,
      config.url,
      JSON.stringify(normalizeData(config.params) || {}),
      JSON.stringify(normalizeData(config.data) || {})
    ].join('|');
  };

//创建axios实例
const service = axios.create({
    baseURL: "/api",
    changeOrigin: true,
    timeout: 20000,
    withCredentials: true,
    headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/x-www-form-urlencoded',
        'userRole': 'WEB',
        'Accept-Language': localStorage.getItem('Accept-Language'),
        'BrowserTimeZone': new Date().getTimezoneOffset() / 60,
    }
})
 
//request   请求拦截器
service.interceptors.request.use(request => {
    // 生成请求key，用于取消重复的相同请求
    const requestKey = generateRequestKey(request);

    // 如果存在相同请求，取消前一个
    if (pendingRequests.has(requestKey)) {
        console.log('取消重复请求request:', requestKey);
        const abortController = pendingRequests.get(requestKey);
        abortController.abort();
    }

    // 为当前请求创建新的控制器
    const controller = new AbortController();
    request.signal = controller.signal;
    pendingRequests.set(requestKey, controller);

    return Promise.resolve(request)
}, err => {
    return Promise.reject(err)
})
 
//response  响应拦截器
service.interceptors.response.use(response => {
    const requestKey = generateRequestKey(response.config);
    pendingRequests.delete(requestKey);
    // console.log('Response=>', response);
    if (response.status == 200) {
        if (response.data.result == 10000 || [401].includes(response.data.code)) {
            // 登录失败，跳转到首页，重新登录
            router.push('/')
            return Promise.reject(response)
        } else {
            return Promise.resolve(response)
        }
    } else {
        return Promise.reject(response)
    }
}, err => {
    if (err.name === 'AbortError') {
        console.log('请求已被取消:', err.message);
        return Promise.reject(new Error('Request cancelled'));
    }
    // 取消请求时，不执行这里的代码
    if (err.config) {
        const requestKey = generateRequestKey(err.config);
        pendingRequests.delete(requestKey);
    }
})

export default service;